module.exports = __webpack_public_path__ + "static/media/prize-4.b444a424.png";